// extracted by mini-css-extract-plugin
export var Banner = "Banner-module--Banner--3ElXX";
export var Container = "Banner-module--Container--Iyfv6";